import React, { useEffect, useRef, useState } from 'react'
import './player-view.styles.scss'

import { Route, Routes, useLocation, useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import PlayerStatusTable from '@/components/PLAYER/player-blocks/components/status-table.component'
import UserIcon from '@/components/layout-auth/user-icon/user-icon.component'
import BackButton from '@/components/SHARED/back-button/back-button.component'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBandage, faEllipsisVertical, faFlag, faGem, faUserPen, faUserSecret } from '@fortawesome/free-solid-svg-icons'
import { ModalAlert, ModalConfirm } from '@/components/modal/modal.component'
import { UseCloudFunction, UseCloudGameTransactions } from '@/utils/firebase.utils'
import MyXpEarningsList from '@/components/PLAYER/player-blocks/components/status-elements/xp/my-xp-earnings-list.component'
import MyBadges from '@/components/PLAYER/player-blocks/components/status-elements/badges/my-badges.component'
import BadgeView from '@/components/PLAYER/player-blocks/components/status-elements/element-view.component'
import MyLevelsList from '@/components/PLAYER/player-blocks/components/status-elements/levels/my-levels-list.component'
import MyCurrencyEarningsList from '@/components/PLAYER/player-blocks/components/status-elements/currency/my-currency-earnings-list.component'
import MySecretCodesList from '@/components/PLAYER/player-blocks/components/status-elements/secret-codes/secret-codes-list.component'
import MyChallengesList from '@/components/PLAYER/player-blocks/components/status-elements/challenges/my-challenges-list.component'
import ImageContainer from '@/components/SHARED/image-container/image-container.component'
import EditPlayer from './edit-player.component'
import DistributeIndividual from './distribute-individual.component'
import InventoryLanding from '@/components/PLAYER/inventory/inventory-landing.component'
import HiddenText from '@/components/SHARED/hidden-text/hidden-text.component'
import { setNewPasscode } from '@/state/slices/contentSlice'
import { getPlayerDataFromDb } from '@/utils/getDataFromDb'
import ThreeDotsLoader from '@/components/loader/three-dots-loader.component'
import TransactionView from '@/components/SHARED/transaction-view/transaction-view.component'
import ElementView from '@/components/PLAYER/player-blocks/components/status-elements/element-view.component'
import QRCodeDownloader from './qr-code-downloader.component'
import useAnalytics from '@/utils/useAnalytics'
import { sortElementsNoThe } from '@/utils/sortElements'
import { completePlayerData } from '@/components/PREVIEW/previewPlayers'

const ManagerPlayerView = ({
  playerList,
  gameElements,
  teamMembers,
  gameData,
  gameActivity,
  setMainAlert,
  gameStats,
  passcodes,
  role
}) => {

  const userProfile = useSelector(state => state.userData.userProfile);
  const screenSize = useSelector(state => state.contentData.screenSize);
  const membership = useSelector(state => state.userData.membership);
  const [playerData, setPlayerData] = useState(null);
  const [playerActivity, setPlayerActivity] = useState({});
  const [showDropdown, setShowDropdown] = useState(false);
  const [alertMessage, setAlertMessage] = useState(null);
  const [confirmMessage, setConfirmMessage] = useState(null);
  const [manager, setManager] = useState(null);
  const [clearLoading, setClearLoading] = useState(null);
  const [ teams, setTeams ] = useState([]);
  const [ assignedTeams, setAssignedTeams ] = useState([]);
  const { trackEvent, trackException } = useAnalytics();
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const root = useSelector(state => state.userData.root)
  const { playerPath } = useParams();
  const approveRef = useRef();
  const playerRef = useRef();
  const location = useLocation();
  let playerListener;

  // useEffect(() => {
  //     const timeout = setTimeout(() => {
  //         if (!playerRef.current) {
  //             navigate(`/404`);
  //         }
  //     }, 2000)

  //     return () => {
  //         if (timeout) clearTimeout(timeout);
  //     }
  // }, [])

  useEffect(() => {

    return () => {
      if (playerListener) playerListener();
    }
  }, [])

  useEffect(() => {
    if (!playerList || !teamMembers || !playerData) return;
    const teamList = sortElementsNoThe(Object.values(playerList).filter(p => p.team))
    setTeams(teamList)
    console.log(teamMembers);
    const assignedTeamIds = Object.values(teamMembers).filter(t => t.members && t.members.includes(playerData.playerId)).map(t => t.teamId);
    const teamArr = [];
    assignedTeamIds.map(id => {
      const team = teamList.filter(t => t.playerId === id)[0];  
      if (team) teamArr.push(team);
    })
    setAssignedTeams(teamArr);
  }, [playerList, teamMembers, playerData])

  useEffect(() => {
    if (!role || !playerPath || !gameData) return;
    if (role === 'owner' || role === 'manager') {
      setManager(true);
    } else {
      getPlayerData();
    }
  }, [role, playerPath, gameData])

  useEffect(() => {
    // document.getElementById('scroll-point').scrollIntoView({'behavior': 'smooth', 'top': '-20px'});
    document.getElementById('scroll-to-top').scrollTo({ 'top': '0px', 'behavior': 'smooth' })

  }, [location])

  useEffect(() => {
    if (!playerPath || !manager) return;
    // const player = Object.values(playerList).filter(p => p.path === playerPath)[0];
    // if (!player) return;

    // playerRef.current = {...player};
    // setPlayerData(playerRef.current);
    // console.log(playerRef.current);

    getPlayerData();

    // console.log(playerList[playerId]);
  }, [playerPath, manager])

  useEffect(() => {
    if (!gameActivity || !playerData) return;
    // console.log(gameActivity)
    const activityObj = {}
    Object.values(gameActivity)
      .filter(a => a.playerId === playerData.playerId)
      .map(a => {
        activityObj[a.id] = a
      })
    setPlayerActivity({ ...activityObj })
  }, [gameActivity, playerData])

  // get playerData from Database if distributor  
  function getPlayerData() {
    if (location.pathname.includes('/preview/manager/')) {
      setPlayerData(Object.values(completePlayerData).find(p => p.path === playerPath));
      return;
    }
    getPlayerDataFromDb({
      'playerPath': playerPath,
      'gameId': gameData.gameId,
      'callback': callback,
      'handleListener': handleListener
    })
    function callback(data) {
      playerRef.current = { ...data };
      setPlayerData(playerRef.current);
    }
    function handleListener(unsub) {
      playerListener = unsub;
    }
  }

  async function resetPasscode() {
    if (location.pathname.includes('/preview/manager/')) {
        setAlertMessage('Sorry! Data cannot be saved in Preview Mode.');
        return;
    }
    const res = await UseCloudFunction(
      'resetPasscode',
      {
        'gameId': gameData.gameId,
        'playerData': playerData,
        'userProfile': userProfile
      }
    )
    console.log(res);
    if (res.error) {
      setAlertMessage('Sorry, something went wrong. Try again later. Error: ' + res.error);
      return;
    }
    setAlertMessage('Passcode reset successfully!');
    dispatch(setNewPasscode({
      'playerId': playerData.playerId,
      'code': res.passcode
    }))
    const resetTimer = setTimeout(() => {
      resetPlayerSignOut();
      clearTimeout(resetTimer);
      trackEvent(
        'player_passcode_reset',
        'Game Manager',
        `Passcode reset for player ${playerData.playerId}.`,
        null,
        membership
      )
    }, 5000)
    // clearTimeout(resetTimer);
  }

  async function resetPlayerSignOut() {
    if (location.pathname.includes('/preview/manager/')) {
        setAlertMessage('Sorry! Data cannot be changed in Preview Mode.');
        return;
    }
    const res = await UseCloudFunction(
      'resetPlayerSignOut', 
      {
        'gameId': gameData.gameId,
        'playerId': playerData.playerId 
      })
    console.log(res);
  }

  function clearPlayerNotifications() {
    if (location.pathname.includes('/preview/manager/')) {
        setAlertMessage('Sorry! Data cannot be changed in Preview Mode.');
        return;
    }
    setConfirmMessage('Are you sure you want to clear this player\'s notifications? This action cannot be undone.');
    approveRef.current = () => {
      continueClear();
    }

    async function continueClear() {
      console.log(playerData.playerId);
      const res = await UseCloudGameTransactions(
        'markRewardAsViewed',
        {
          'gameId': gameData.gameId,
          'playerId': playerData.playerId,
          'rewardIdArr': playerData.newStuff,
        }
      )
      console.log(res);
      if (res.error) {
        setAlertMessage(`Something went wrong. Please try again later. (Error: ${res.error})`);
        trackException(`Error clearing notifications for player ${playerData.playerId} in game ${gameData.gameId}: ${res.error}`);
        return;
      }
      setAlertMessage('Player notifications cleared successfully.');
      trackEvent(
        'player_notifications_cleared',
        'Game Manager',
        `Notifications cleared for player ${playerData.playerId}.`,
        null,
        membership
      )
    }
  }


  function cancel() {
    navigate(-1);
  }


  return (
    <div className={`player-view-container ${screenSize}`}>
      <div></div>
      <Routes>
        <Route path='' element={
          <div className='player-view-content'>
            <div className='g-card'>
              <div className='top-row'>
                <BackButton cancel={cancel} />
                {/* <button className='g-button text-only more-button' onClick={() => setShowDropdown(!showDropdown)}>
                                    <FontAwesomeIcon icon={faEllipsisVertical} className='clickable static' size='xl' />
                                </button>
                                <div className={`dropdown ${!showDropdown ? 'hidden' : ''}`}>
                                    <div className='content'>
                                        <button className='g-button text-only' onClick={() => clearNewStuff()}>Clear Rewards Notifications</button>
                                    </div>
                                </div> */}
              </div>
              {
                (playerData) &&
                <>
                  <div className="g-space-1"></div>
                  <div className={`player-view-head ${screenSize}`}>
                    <div className='player-head-text'>
                      <UserIcon
                        profile={playerData}
                        large={screenSize === 'desktop'}
                        noHover={true} />
                      <div className='name'>
                        {playerData.fName} {playerData.lName}
                        {
                          (passcodes && passcodes[playerData.playerId]) &&
                          <div className='passcode-content'>
                            <div className='meta'>
                              <div>Passcode:</div>

                              <HiddenText
                                text={passcodes[playerData.playerId]}
                                hidden={true}
                                stars={4}
                              />
                              <button
                                className={`g-button ${screenSize === 'mobile' || screenSize === 'tablet' ? 'tiny-btn' : 'small-btn '}`}
                                onClick={() => resetPasscode(playerData.playerId)}
                              >
                                New Code
                              </button>
                            </div>

                          </div>
                        }
                      </div>
                      {/* <div className='' */}
                    </div>
                    <div className={`player-head-controls ${screenSize}`}>
                      <button
                        className={`g-button small-btn`}
                        onClick={() => navigate('distribute')}>
                        {
                          screenSize === 'mobile' || screenSize === 'tablet'
                            ? ''
                            : 'Distribute'}
                        <FontAwesomeIcon icon={faGem} />
                      </button>
                      {
                        (manager) &&
                        <>
                          <button
                            className={`g-button small-btn`}
                            onClick={() => navigate('edit')} >
                            {
                              screenSize === 'mobile' || screenSize === 'tablet'
                                ? ''
                                : 'Edit Player'}
                            <FontAwesomeIcon icon={faUserPen} />
                          </button>
                          {/* <QRCodeDownloader value={playerData.path} /> */}
                          {
                            (playerData.newStuff && playerData.newStuff.length > 0)
                              ?
                              (
                                (clearLoading)
                                  ?
                                  <button className='g-button small-btn'>
                                    <ThreeDotsLoader />
                                  </button>
                                  :
                                  <button
                                    className={`g-button small-btn`}
                                    onClick={() => clearPlayerNotifications()}>
                                    {
                                      screenSize === 'mobile' || screenSize === 'tablet'
                                        ? 'Clear'
                                        : 'Clear Notifications'}
                                    <FontAwesomeIcon icon={faFlag} />
                                  </button>
                              )
                              :
                              <button className={`g-button disabled ${screenSize === 'mobile' || screenSize === 'tablet'
                                  ? 'tiny-btn'
                                  : 'small-btn'}`}>
                                {
                                  screenSize === 'mobile' || screenSize === 'tablet'
                                    ? 'Clear'
                                    : 'Clear Notifications'
                                }
                                <FontAwesomeIcon icon={faFlag} />
                              </button>
                          }
                        </>
                      }
                    </div>
                  </div>
                  {
                    teams.length > 0 &&
                    <div className="team-info-container">
                      <div className="g-space-1"></div>
                      <div className="g-list-item team-info">
                        <div className="">
                          Assigned Team(s): 
                        </div>
                        <div className="team-list">
                          {
                            assignedTeams.length > 0
                            ?
                            assignedTeams.map((t, i) => {
                              return (
                                <div key={t.playerId} className='team-name'>
                                  <div className="team-icon">
                                    <ImageContainer
                                      className="icon"
                                      src={t.icon} />
                                  </div>
                                  {t.fName}
                                  {
                                    (
                                      screenSize !== 'mobile' && 
                                      screenSize !== 'tablet' &&
                                      assignedTeams.length > i + 1
                                    ) &&
                                    <span>, </span>
                                  }
                                </div>
                              )
                            })
                            :
                            <div className='grey'>No teams assigned</div>
                          }
                        </div>
                      </div>
                    </div>
                  }
                  <div className="g-space-1"></div>
                  <PlayerStatusTable role={role} playerData={playerData} gameData={gameData} gameElements={gameElements} playerActivity={playerActivity} />
                </>
              }
              {/* <div className='g-space-1'></div>
              <div className='meta'>{playerData ? playerData.playerId : ''}</div> */}
            </div>
            <div className="g-space-2"></div>
          </div>
        }></Route>
        <Route
          path='xp/*'
          element={
            <MyXpEarningsList
              gameData={gameData}
              playerData={playerData}
              gameElements={gameElements} />
          }></Route>
        <Route
          path='badges'
          element={
            <MyBadges 
              gameData={gameData}
              playerData={playerData} 
              gameElements={gameElements} />
          }></Route>
        <Route
          path='badges/:elementPath/*'
          element={
            <ElementView 
              gameData={gameData}
              playerData={playerData} 
              gameElements={gameElements} />
          }></Route>
        <Route
          path='levels'
          element={
            <MyLevelsList 
              gameData={gameData}             
              playerData={playerData} 
              gameElements={gameElements} />
          }></Route>
        <Route
          path='levels/:elementPath/*'
          element={
            <ElementView 
              gameData={gameData}             
              playerData={playerData} 
              gameElements={gameElements} />
          }></Route>
        <Route path='currency/*' element={
          <MyCurrencyEarningsList
            gameData={gameData}
            playerData={playerData}
            gameElements={gameElements}
          />
        }></Route>
        <Route path='currencytotal/*' element={
          <MyCurrencyEarningsList
            gameData={gameData}
            playerData={playerData}
            gameElements={gameElements}
            total={true}
          />
        }></Route>
        <Route path='inventory/*' element={
          <InventoryLanding
            gameData={gameData}
            playerData={playerData}
            gameElements={gameElements}
            playerActivity={playerActivity}
            gameStats={gameStats}
          />
        } ></Route>
        <Route path='secretcodes' element={
          <MySecretCodesList
            playerData={playerData}
            gameElements={gameElements}
            playerActivity={playerActivity}
          />
        }></Route>
        <Route path='secretcodes/:elementPath/*' element={
          <ElementView
            gameData={gameData}
            playerData={playerData}
            gameElements={gameElements}
            isSecretCode={true} />
        }></Route>
        <Route path='challenges' element={
          <MyChallengesList
            gameData={gameData}
            playerData={playerData}
            gameElements={gameElements}
            playerActivity={playerActivity}
          />
        }></Route>
        <Route path='edit' element={
          <EditPlayer
            playerData={playerData}
            gameData={gameData}
            setMainAlert={setMainAlert}
          />
        }></Route>
        <Route path='distribute' element={
          <div className='distribute-container'>
            <div className='g-card'>
              <BackButton cancel={() => navigate(-1)} />
              <div className="g-space-1"></div>
              <DistributeIndividual
                gameData={gameData}
                gameElements={gameElements}
                playerData={playerData}
                setAlertMessage={setAlertMessage}
              />
            </div>
            <div className="g-space-2"></div>
          </div>
        }></Route>
      </Routes>
      <ModalAlert 
        show={alertMessage} 
        cancel={() => setAlertMessage(null)} 
        message={alertMessage} />
      <ModalConfirm 
        show={confirmMessage} 
        cancel={() => setConfirmMessage(null)} 
        message={confirmMessage} 
        onApprove={approveRef.current} />
    </div>
  )
}

export default ManagerPlayerView;